import * as React from 'react';
import packageInfo from 'search-insights/package.json';
import { useCookieConsentContext, isCookieCategoryEnabled } from '@grandvisionhq/cookie-consent';

const ALGOLIA_INSIGHTS_VERSION = packageInfo.version;
// You may be tempted to render this component in something like Next.js Head,
// but that will break accessing the cookie consent context, due to the magic that
// goes on in inside the Head component. The result of that magic is that the context will always return null.
// As a workaround we are passing in the Next.js Head and Next.js Script components
// so that this consent dependent component can be rendered anywhere (under the cookie-consent context provider)
// and we still have the scripts and links in the html <head> tag where we need them.
const AlgoliaAnalytics = ({ appId , apiKey , HeadComponent , ScriptComponent ,  })=>{
    const consentResult = useCookieConsentContext();
    if (!apiKey || !appId || !ALGOLIA_INSIGHTS_VERSION) {
        console.warn('Unable to initialize Algolia Insights! Check the appId, apiKey and the search-insights package version.');
        return null;
    }
    const HeadWrapper = HeadComponent ? HeadComponent : React.Fragment;
    const __html = `var ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@${ALGOLIA_INSIGHTS_VERSION}";
  !function(e,a,t,n,s,i,c){e.AlgoliaAnalyticsObject=s,e[s]=e[s]||function(){
  (e[s].queue=e[s].queue||[]).push(arguments)},i=a.createElement(t),c=a.getElementsByTagName(t)[0],
  i.async=1,i.src=n,c.parentNode.insertBefore(i,c)
  }(window,document,"script",ALGOLIA_INSIGHTS_SRC,"aa");
  // Initialize library
  // TODO: move this to AlgoliaConfig
  aa('init', {
    appId: "${appId}",
    apiKey: "${apiKey}",
    useCookie: ${isCookieCategoryEnabled('analytics', consentResult)}
  });`;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(HeadWrapper, null, /*#__PURE__*/ React.createElement("link", {
        rel: "preconnect",
        href: "https://cdn.jsdelivr.net/"
    })), ScriptComponent ? /*#__PURE__*/ React.createElement(ScriptComponent, {
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
            __html
        }
    }) : /*#__PURE__*/ React.createElement("script", {
        dangerouslySetInnerHTML: {
            __html
        }
    }));
};

export { AlgoliaAnalytics };
//# sourceMappingURL=AlgoliaAnalytics.js.map
